module.exports = __webpack_public_path__ + "img/Proliferation-PRCA_SpatialResearch.e6223f26.png";